module.exports = __webpack_public_path__ + "static/media/reactjs-optimized.54302ed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/02-blazing-fast/images/reactjs-optimized.jpg
// module id = 929
// module chunks = 0